export { default } from './GitHubRepos';
